/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAnalytics } from '../models/api-response-analytics';
import { ApiResponseOrderRecency } from '../models/api-response-order-recency';
import { ApiResponsePagedResultConversationItemList } from '../models/api-response-paged-result-conversation-item-list';
import { getExpiredConversations } from '../fn/reporting-api/get-expired-conversations';
import { GetExpiredConversations$Params } from '../fn/reporting-api/get-expired-conversations';
import { getMessageReceived } from '../fn/reporting-api/get-message-received';
import { GetMessageReceived$Params } from '../fn/reporting-api/get-message-received';
import { getOrderRecency } from '../fn/reporting-api/get-order-recency';
import { GetOrderRecency$Params } from '../fn/reporting-api/get-order-recency';
import { getWaitingAgent } from '../fn/reporting-api/get-waiting-agent';
import { GetWaitingAgent$Params } from '../fn/reporting-api/get-waiting-agent';
import { getWaitingCustomer } from '../fn/reporting-api/get-waiting-customer';
import { GetWaitingCustomer$Params } from '../fn/reporting-api/get-waiting-customer';
import { searchAnalytics } from '../fn/reporting-api/search-analytics';
import { SearchAnalytics$Params } from '../fn/reporting-api/search-analytics';

@Injectable({ providedIn: 'root' })
export class ReportingApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getWaitingCustomer()` */
  static readonly GetWaitingCustomerPath = '/v1/api/ui/reporting/waiting-customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWaitingCustomer$Response(params: GetWaitingCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
    return getWaitingCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWaitingCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWaitingCustomer(params: GetWaitingCustomer$Params, context?: HttpContext): Observable<ApiResponsePagedResultConversationItemList> {
    return this.getWaitingCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultConversationItemList>): ApiResponsePagedResultConversationItemList => r.body)
    );
  }

  /** Path part for operation `getWaitingAgent()` */
  static readonly GetWaitingAgentPath = '/v1/api/ui/reporting/waiting-agent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWaitingAgent$Response(params: GetWaitingAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
    return getWaitingAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWaitingAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWaitingAgent(params: GetWaitingAgent$Params, context?: HttpContext): Observable<ApiResponsePagedResultConversationItemList> {
    return this.getWaitingAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultConversationItemList>): ApiResponsePagedResultConversationItemList => r.body)
    );
  }

  /** Path part for operation `getMessageReceived()` */
  static readonly GetMessageReceivedPath = '/v1/api/ui/reporting/message_received';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMessageReceived()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMessageReceived$Response(params: GetMessageReceived$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
    return getMessageReceived(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMessageReceived$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMessageReceived(params: GetMessageReceived$Params, context?: HttpContext): Observable<ApiResponsePagedResultConversationItemList> {
    return this.getMessageReceived$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultConversationItemList>): ApiResponsePagedResultConversationItemList => r.body)
    );
  }

  /** Path part for operation `getExpiredConversations()` */
  static readonly GetExpiredConversationsPath = '/v1/api/ui/reporting/expired-conversation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExpiredConversations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getExpiredConversations$Response(params: GetExpiredConversations$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
    return getExpiredConversations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExpiredConversations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getExpiredConversations(params: GetExpiredConversations$Params, context?: HttpContext): Observable<ApiResponsePagedResultConversationItemList> {
    return this.getExpiredConversations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultConversationItemList>): ApiResponsePagedResultConversationItemList => r.body)
    );
  }

  /** Path part for operation `searchAnalytics()` */
  static readonly SearchAnalyticsPath = '/v1/api/ui/reporting/analytics-chat';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAnalytics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAnalytics$Response(params: SearchAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnalytics>> {
    return searchAnalytics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAnalytics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAnalytics(params: SearchAnalytics$Params, context?: HttpContext): Observable<ApiResponseAnalytics> {
    return this.searchAnalytics$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAnalytics>): ApiResponseAnalytics => r.body)
    );
  }

  /** Path part for operation `getOrderRecency()` */
  static readonly GetOrderRecencyPath = '/v1/api/ui/reporting/order-recency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderRecency()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderRecency$Response(params: GetOrderRecency$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrderRecency>> {
    return getOrderRecency(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrderRecency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderRecency(params: GetOrderRecency$Params, context?: HttpContext): Observable<ApiResponseOrderRecency> {
    return this.getOrderRecency$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOrderRecency>): ApiResponseOrderRecency => r.body)
    );
  }

}
